import {checkEmpty} from "./util.service";
import {checkFileCanUploadBackend, getFiles} from "./files.service";
import {months, supportViewer} from "src/pages/filePage/properies.file";

export function checkFileForRunningNumber(
  name: string,
  type: string,
  ls: any,
  fromUploaded: any
) {
  for (let a = 0; a < ls?.length; a++) {
    let conditionName = ls[a].name_;
    let conditionType = ls[a].type_;
    if (fromUploaded) conditionName = ls[a].file_name;
    if (fromUploaded) conditionType = ls[a].file_type;
    if (conditionName === name.trim() && conditionType === type.trim()) {
      return 1;
    }
  }

  return 0;
}

export const isTrue = (val: any) => {
  if (val === true || val === "true") return true;
  else return false;
};

export function checkAlready(ls: any, file: any) {
  for (let a = 0; a < ls.length; a++) {
    if (ls[a].fullName === file.name) return true;
  }
  return false;
}

export async function getFinalName(
  name_: string,
  type_: string,
  fileToUpload: any,
  currentFolder: any,
  groupId: string,
  userId: string
) {
  let finalName = name_;

  //check name in uploaded
  let text = 1;
  let needCheckUploaded = false;
  let needCheckQ = false;
  let parentFolderId = "";
  // console.log("currentFolder : ",currentFolder)
  if (isTrue(currentFolder?.control_version)) {
    needCheckUploaded = false;
    needCheckQ = false;
  } else {
    needCheckUploaded = true;
    needCheckQ = true;
  }
  if (checkEmpty(currentFolder?.file_app_id)) {
    needCheckUploaded = true;
    needCheckQ = true;
  } else {
    parentFolderId = currentFolder?.file_app_id;
  }
  if (checkEmpty(parentFolderId)) parentFolderId = "";
  console.log("needCheckUploaded", needCheckUploaded);
  if (needCheckUploaded) {
    let paramemersFileT: any = {};
    paramemersFileT.limitOfset = null;
    paramemersFileT.offset = 0;
    paramemersFileT.active = "all";
    paramemersFileT.groupId = groupId;
    paramemersFileT.userId = userId;
    paramemersFileT.parentFolderId = parentFolderId;
    let res_1: any = await getFiles(paramemersFileT);
    let files = res_1.data?.filter((item: any) => {
      return item.type_ === "FILE";
    });
    console.log("files", files);
    let length = checkFileForRunningNumber(name_, type_, files, true);
    if (length > 0) {
      while (true) {
        let name = name_ + " (" + text + ")";

        length = checkFileForRunningNumber(name, type_, files, true);
        if (length > 0) {
          text++;
        } else {
          finalName = name;
          break;
        }
      }
    }
  }

  // check name in Q
  if (needCheckQ) {
    let length = checkFileForRunningNumber(
      finalName,
      type_,
      fileToUpload,
      false
    );
    if (length > 0) {
      while (true) {
        let name = name_ + " (" + text + ")";

        length = checkFileForRunningNumber(name, type_, fileToUpload, false);
        if (length > 0) {
          text++;
        } else {
          finalName = name;
          break;
        }
      }
    }
  }

  console.log("finalName", finalName);
  return finalName;
}

export async function getFinalNameChat(
  name_: string,
  type_: string,
  groupId: string,
  actionType: any
) {
  let finalName = name_;

  //check name in uploaded
  let text = 1;
  // console.log("currentFolder : ",currentFolder)

  let paramemersFileT: any = {};
  paramemersFileT.limitOfset = null;
  paramemersFileT.offset = 0;
  paramemersFileT.active = "all";
  paramemersFileT.groupId = groupId;
  paramemersFileT.userId = null;
  paramemersFileT.actionType = actionType;
  let res_1: any = await getFiles(paramemersFileT);
  let files = res_1.data?.filter((item: any) => {
    return item.type_ === "FILE";
  });
  console.log("files", files);
  let length = checkFileForRunningNumber(name_, type_, files, true);
  if (length > 0) {
    while (true) {
      let name = name_ + " (" + text + ")";

      length = checkFileForRunningNumber(name, type_, files, true);
      if (length > 0) {
        text++;
      } else {
        finalName = name;
        break;
      }
    }
  }

  console.log("finalName", finalName);
  return finalName;
}
export const reflectorFileFoldersDelete = (
  files: any,
  type: string,
  res: any
) => {
  let i = files.findIndex((item: any) => {
    return item.file_app_id === res.file_app_id;
  });
  if (i != -1) {
    files.splice(i, 1);
  }
  let newLenght = files.lenght;
  return { files, newLenght };
};

export const reflectorFileFolders = (
  fileFolders: any,
  type: string,
  res: any
) => {
  let filesT = fileFolders.filter((item: any) => {
    return item.type_ === "FILE";
  });
  let foldersT = fileFolders?.filter((item: any) => {
    return item.type_ === "DIRECTORY";
  });

  let response = [];
  fileFolders = [];

  let newLenght;
  if (type === "DIRECTORY") {
    fileFolders = fileFolders.concat(res);
    fileFolders = fileFolders.concat(foldersT);
    newLenght = fileFolders?.length + 1;
  } else {
    if (!checkEmpty(res.length)) {
      for (let a = 0; a < res.length; a++) {
        let indexFile = filesT.findIndex((item: any) => {
          return (
            item.file_name === res[a].file_name &&
            item.file_type === res[a].file_type
          );
        });
        if (indexFile != -1) {
          filesT.splice(indexFile, 1);
        }
        response.push(res[a]);
      }
    } else if (!checkEmpty(res)) {
      response.push(res);
    }

    fileFolders = fileFolders.concat(foldersT);
    fileFolders = fileFolders.concat(response);
    newLenght = fileFolders?.length + response.length;
  }
  fileFolders = fileFolders.concat(filesT);
  return { fileFolders, newLenght };
};

export function sizeToBytse(limitSize: any) {
  if (limitSize === null || limitSize === undefined) return 0;
  let tSizes = limitSize?.trim().split(" ");
  let bytes = 0;
  if (tSizes[1] === "TB")
    bytes = parseInt(tSizes[0]) * 1024 * 1024 * 1024 * 1024;
  if (tSizes[1] === "GB") bytes = parseInt(tSizes[0]) * 1024 * 1024 * 1024;
  if (tSizes[1] === "MB") bytes = parseInt(tSizes[0]) * 1024 * 1024;
  if (tSizes[1] === "KB") bytes = parseInt(tSizes[0]) * 1024;
  if (tSizes[1] === "Bytes") bytes = parseInt(tSizes[0]);

  return bytes;
}

export function getClassAndType(fullName: string) {
  let names = fullName.split(".");
  let name_ = "";
  let type_ = "";
  for (let a = 0; a < names.length; a++) {
    if (a === 0) name_ = names[a];
    else if (a > 0 && a != names.length - 1) name_ = name_ + "." + names[a];
    else type_ = names[a];
  }
  return { name_, type_ };
}

export function calPercentProgressBtnMain(fileToUploadShow: any) {
  let total = 0,
    used = 0;
  let cancleSize = 0;
  let oldPercent = 0;
  for (let a = 0; a < fileToUploadShow?.length; a++) {
    if (
      fileToUploadShow[a].status !== "cancel" &&
      fileToUploadShow[a].status !== "error"
    ) {
      used += fileToUploadShow[a]?.loaded ? fileToUploadShow[a]?.loaded : 0;
      total += fileToUploadShow[a]?.size ? fileToUploadShow[a]?.size : 0;
    }
    if (
      fileToUploadShow[a].status === "cancel" ||
      fileToUploadShow[a].status === "error"
    ) {
      cancleSize++;
      oldPercent += fileToUploadShow[a]?.percent;
    }
  }
  let status = "normal";
  if (cancleSize === fileToUploadShow.length) {
    status = "cancel";
    percent = oldPercent / fileToUploadShow.length;
  } else {
    var percent = (used / total) * 100;
    percent = Math.round(percent);
    if (percent >= 100) {
      percent = 100;
      status = "done";
    }
  }
  return { percent: percent, status: status };

}

export const onChangeSelectFileMain = async (
  event: any,
  fileContext: any,
  inputFileToUploadEl: any
) => {
  try {
    // fileContext.setShowModalUpload(true);
    let isCheckIn = false; ///////////////
    let limitPerfileText = fileContext.aboutLimit?.limitSizePerFile;
    let limitSizePerFile = sizeToBytse(limitPerfileText);
    let fileToUploadT = Object.assign([], fileContext.fileToUpload);
    let files = event.target.files;
    fileContext.setCheckingFile(true);
    for (let a = 0; a < files.length; a++) {
      let file = files[a];
      let d = getClassAndType(file.name);
      d.name_ = await getFinalName(
        d.name_,
        d.type_,
        fileContext.fileToUpload,
        fileContext.currentFolder,
        fileContext.groupId,
        fileContext.userId
      );

      file.name_ = d.name_;
      file.fullName = file.name_ + "." + d.type_;
      file.type_ = d.type_;
      file.size_ = file.size;
      file.lastModified_ = file.lastModified;

      let isOversize = false;
      if (file.size_ > limitSizePerFile) isOversize = true;
      let already = checkAlready(fileToUploadT, file);
      if (isCheckIn) {
        if (
          file.name_ === fileContext.fileSelected?.file_name &&
          file.type_ === fileContext.fileSelected?.file_type
        ) {
          fileToUploadT = [];
        } else {
          //alert
          // setMessageNoti(t("Please import same file name as you checked out."));
          // setShowNoti(true);
        }
      } else {
        if (isTrue(fileContext.currentFolder?.control_version)) {
          let dataCanUpload: any = await checkFileCanUploadBackend(
            file,
            fileContext.currentFolder
          );
          if (isTrue(dataCanUpload.can)) {
            if (isOversize === true) {
              // setMessageNoti(
              //   t("Please select file less than") +
              //     " " +
              //     aboutLimit.limitSizePerFile
              // );
              // setShowNoti(true);

              fileContext.setUploadErrorMessage("The file is too large.");
              fileContext.setUploadErrorDescription(
                "Please select file less than " +
                  bytesToSize(limitSizePerFile)?.replace(" ", "")
              );
            } else {
              // fileToUpload.push(file);
              fileToUploadT.push(file);
              fileContext.setShowModalUpload(true);
            }
          } else {
            //alert
            let user_id = dataCanUpload.checkOutObj?.user_id;
            // setMessageNoti(
            //   t(
            //     "${userId} is currently checked out this file. Please wait for ${userId} to cancel check out or check in new file."
            //   )
            //     .split("${userId}")
            //     .join(user_id)
            // );
            // setShowNoti(true);
          }
        } else {
          if (!already) {
            if (isOversize === true) {
              // setMessageNoti(
              //   t("Please select file less than") +
              //     " " +
              //     fileContext.aboutLimit.limitSizePerFile
              // );
              // setShowNoti(true);

              fileContext.setUploadErrorMessage("The file is too large.");
              fileContext.setUploadErrorDescription(
                "Please select file less than " +
                  bytesToSize(limitSizePerFile)?.replace(" ", "")
              );
            } else {
              fileToUploadT.push(file);
              fileContext.setShowModalUpload(true);
            }
          }
        }
      }
      fileContext.setFileToUpload(Object.assign([], fileToUploadT));
    }
    fileContext.setCheckingFile(false);
    fileContext.setFileToUpload(Object.assign([], fileToUploadT));
    inputFileToUploadEl.current.value = null;
  } catch (e) {
    console.error(e);
  }
};

export function reverseArr(input: any) {
  var ret = new Array();
  for (var i = input.length - 1; i >= 0; i--) {
    ret.push(input[i]);
  }
  return ret;
}
export function calFreeSize_Split(used: any, limitSize: any) {
  let fullSize = sizeToBytse(limitSize);
  let freeSize = fullSize - used;
  if (freeSize <= 0) freeSize = 0;
  let freeSizeObj = bytesToSize_Split(freeSize);
  let size = 0;
  let typeOfSize = "MB";
  if (checkEmpty(freeSizeObj)) {
    size = 0;
    typeOfSize = "MB";
  }
  size = freeSizeObj.size;
  typeOfSize = freeSizeObj.typeOfSize;
  return { size: size, typeOfSize: typeOfSize };
}
export function bytesToSize_Split(bytes: any) {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return { size: 0, typeOfSize: "GB" };
  //@ts-ignore
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  let size =
    Math.round((bytes / Math.pow(1024, i) + Number.EPSILON) * 100) / 100;

  let typeOfSize = sizes[i];
  if (checkEmpty(size) || Number.isNaN(size)) size = 0;
  if (checkEmpty(typeOfSize)) typeOfSize = "MB";
  return { size: size, typeOfSize: typeOfSize };
}
export function bytesToSize(bytes: any) {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";

  //@ts-ignore
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return (
    Math.round((bytes / Math.pow(1024, i) + Number.EPSILON) * 100) / 100 +
    " " +
    sizes[i]
  );
}

export function calPercentProgressBtnPercent(fileToUploadShow: any) {
  let v = calPercentProgressBtnMain(fileToUploadShow);
  if (Number.isNaN(v.percent)) return 0;
  // console.log("percent : ", v.percent);
  
  return v.percent;
}

export const getDateFormat_1 = (dateData: any, t: any) => {
  try {
    let date = new Date(dateData);
    // console.log(date.getDate());
    let min: any = date.getMinutes();
    if (min < 10) min = "0" + min;
    let hours: any = date.getHours();
    if (hours < 10) hours = "0" + hours;
    let timeData =
      t(months[date.getMonth()]) +
      " " +
      date.getDate() +
      ", " +
      date.getFullYear() +
      " | " +
      hours +
      ":" +
      min;
    return timeData;
  } catch (e) {
    console.log(e);
    return dateData;
  }
};
export const getDateFormat_2 = (dateData: any, t: any) => {
  try {
    let date = new Date(dateData);
    // console.log(date.getDate());
    let min: any = date.getMinutes();
    if (min < 10) min = "0" + min;
    let hours: any = date.getHours();
    if (hours < 10) hours = "0" + hours;
    let timeData =
      t(months[date.getMonth()]) +
      " " +
      date.getDate() +
      ", " +
      date.getFullYear();
    // " | " +
    // hours +
    // ":" +
    // min;
    return timeData;
  } catch (e) {
    console.log(e);
    return dateData;
  }
};

export async function getFileByCurrentAndName(
  name: any,
  currentFolder: any,
  groupId: any,
  userId: any,
  fileSelected: any
) {
  let parentFolderId = "";
  if (!checkEmpty(currentFolder?.file_app_id))
    parentFolderId = currentFolder?.file_app_id;
  let param = {
    groupId: groupId,
    userId: userId,
    offset: 0,
    type: "BOTH",
    parentFolderId: parentFolderId,
  };
  let res: any = await getFiles(param);
  let fileFoldersT = res.data;
  if (fileSelected.type_ === "DIRECTORY") {
    if (checkEmpty(fileFoldersT)) fileFoldersT = [];
    let folders = fileFoldersT.filter((item: any) => {
      return item.type_ === "DIRECTORY";
    });
    for (let a = 0; a < folders.length; a++) {
      if (folders[a].file_name === name.trim()) {
        return 1;
      }
    }
  } else {
    let files = fileFoldersT.filter((item: any) => {
      return item.type_ === "FILE";
    });
    for (let a = 0; a < files.length; a++) {
      if (
        files[a].file_name === name.trim() &&
        files[a].file_type === fileSelected.file_type.trim()
      ) {
        return 1;
      }
    }
  }

  return 0;
}

export function calPercent(limitSize: any) {
  let used = limitSize?.used;
  let limit = limitSize?.limitSize;
  let total = sizeToBytse(limit);
  let percent = (used / total) * 100;
  if (checkEmpty(percent) || Number.isNaN(percent)) return percent;
  return percent;
}
export const getNameOfUser = (user: any) => {
  user = user.friend;
  let textName = "";
  if (!checkEmpty(user?.firstname)) {
    if (!checkEmpty(user?.lastname)) {
      textName = user?.firstname + " " + user?.lastname;
    } else {
      textName = user?.firstname;
    }
  } else {
    textName = user?.username;
  }
  return textName;
};
export const getNameOfUserNotFriend = (user: any) => {
  let textName = "";
  if (!checkEmpty(user?.firstname)) {
    if (!checkEmpty(user?.lastname)) {
      textName = user?.firstname + " " + user?.lastname;
    } else {
      textName = user?.firstname;
    }
  } else {
    textName = user?.username;
  }
  return textName;
};

export function calFreeSize(used: any, limitSize: any) {
  let fullSize = sizeToBytse(limitSize);
  let freeSize = fullSize - used;
  if (freeSize <= 0) freeSize = 0;
  return freeSize;
}

export function downloadFile(file: any) {
  try {
    let link =
      window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER +
      "/downloadFile" +
      "?fileId=" +
      file.file_app_id;
    //@ts-ignore
    document.getElementById("my_iframe_Download").src = link;
  } catch (e) {
    console.log("E :", e);
  }
}

export function getPathSpace(path: string) {
  if (checkEmpty(path)) return "";
  let final = "";
  let paths = path.split("/");
  for (let a = 0; a < paths.length - 1; a++) {
    // console.log(a, paths[a]);
    if (a != 0) final = final + " / " + paths[a];
    else {
      final = final + paths[a];
    }
  }
  return final;
}

export function fetchNextUtil(
  fileContext: any,
  data: any,
  setOffsetFile: any,
  defaultLitmitOfset: any,
  offsetFile: any
) {
  let hasMore;
  let offsetFileRes = offsetFile;
  console.log("1loading more...", data);
  console.log("2loading more...", fileContext.fileFolders);
  if (fileContext.fileFolders?.length + defaultLitmitOfset >= data?.total) {
    fileContext.setHasMore(false);
    hasMore = false;
  }
  if (fileContext.fileFolders?.length >= data?.total) {
    fileContext.setHasMore(false);
    hasMore = false;
  }
  if (fileContext.fileFolders?.length < data?.total) {
    fileContext.setLoadMore(true);
    fileContext.setHasMore(true);
    setOffsetFile(offsetFile + defaultLitmitOfset);
    offsetFileRes = offsetFile + defaultLitmitOfset;
    hasMore = true;
  }
 
  return { hasMore: hasMore, offsetFile: offsetFileRes };
}
export const bytesToSizeUtil = (bytes: any) => {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";
  //@ts-ignore
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  let v = Math.round((bytes / Math.pow(1024, i) + Number.EPSILON) * 100) / 100;
  if (isNaN(v)) v = 0;
  let v2 = sizes[i];
  if (checkEmpty(v2)) v2 = "MB";
  return v + " " + v2;
};
export function addCommas(nStr: any) {
  nStr += "";
  var x = nStr.split(".");
  var x1 = x[0];
  var x2 = x.length > 1 ? "." + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  return x1 + x2;
}
export const checkImg = async (URL: any) => {
  return new Promise((resolve, reject) => {
    var tester = new Image();
    tester.onload = function () {
      resolve(true);
    };
    tester.onerror = function () {
      resolve(false);
    };
    tester.src = URL;
  });
};

export function getPosition(el: any) {
  var xPos = 0;
  var yPos = 0;

  while (el) {
    if (el.tagName == "BODY") {
      // deal with browser quirks with body/window/document and pages scroll
      var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
      var yScroll = el.scrollTop || document.documentElement.scrollTop;

      xPos += el.offsetLeft - xScroll + el.clientLeft;
      yPos += el.offsetTop - yScroll + el.clientTop;
    } else {
      // for all other non-BODY elements
      xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
      yPos += el.offsetTop - el.scrollTop + el.clientTop;
    }

    el = el.offsetParent;
  }
  return {
    x: xPos,
    y: yPos,
  };
}
export const isImgType = (type: any) => {
  for (let a = 0; a < supportViewer.images.length; a++) {
    if (supportViewer.images[a].toUpperCase() === type.toUpperCase()) {
      // console.log("type : "+type)
      return true;
    }
  }

  return false;
};
